import { Page } from "../../../components/Page";
import { Card } from "../../../components/Card";
import { Flex, Heading, Text, useToast } from "@chakra-ui/react";
import { useGetTotalEmissions } from "../../../hooks/query/emissions-insight/emissions-insights-query";
import { Footprints } from "@phosphor-icons/react";
import FootPrint from "./components/FootPrint";
import { H1 } from "../../../components/text/headings";

const EmissionsInsights = () => {
  return (
    <Page>
      <Flex direction="column" gap={2} mx="10%">
        <H1>Insights</H1>
        <Text maxW="75%" color="gray.500" fontSize="body.m">
          Monitor and track key indicators and trends on sustainability performance across your organisation and supply
          chain all in one place.
        </Text>

        <FootPrint />
      </Flex>
    </Page>
  );
};

export default EmissionsInsights;
